'use client';

import {
  COOKIE_TMR_LVID,
  COOKIE_YM_UID,
  getCookie,
  getUserIpFromCookieInWebCatalog,
  waitForCookies,
} from '@utils/cookies';
import {generateMyTrackerPixel} from '@utils/pixel';
import {useTracePathname} from '@utils/tracer/useTracePathname';
import {getEnvConfig} from '@web-catalog/env';
import {usePathname, useSearchParams} from 'next/navigation';
import {useEffect} from 'react';

import {
  emitTmrEvent,
  emitYmEvent,
  enableTmrDebugging,
} from '@web-catalog/utils/analytics';

import {Props} from './types';

export const ScriptsInitialization = ({userIp, envConfig}: Props) => {
  const searchParams = useSearchParams();
  const path = usePathname();

  const {YA_METRIKA_ID} = envConfig;

  useEffect(() => {
    generateMyTrackerPixel({
      cookieDomain: envConfig.COOKIE_DOMAIN,
      userIp: getUserIpFromCookieInWebCatalog() || userIp || '',
      serviceVersion: `${process.env.APP_VERSION}`,
      appDeeplinkBaseUrl: getEnvConfig().DEEPLINK_BASE,
      emitPixelEvents: (payload) => {
        emitTmrEvent({
          eventName: 'mt_pixel',
          params: {
            ...payload,
            metrikaUid: getCookie(COOKIE_YM_UID) ?? '',
            pageURL: document.location.href.split('?')[0],
          },
        });

        emitYmEvent({eventName: 'mt_pixel', params: payload});
      },
    });
  }, [envConfig, searchParams, userIp]);

  useEffect(() => {
    if (searchParams?.has('_tmr_debug')) {
      enableTmrDebugging();
    }

    waitForCookies({names: [COOKIE_TMR_LVID], maxWaitMs: 10_000}).then(
      ([tmrCookie]) => {
        if (tmrCookie && window.ym) {
          window.ym(YA_METRIKA_ID, 'userParams', {tmr_lvid: tmrCookie});
        }
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.ym) {
      window.ym(YA_METRIKA_ID, 'hit', document.location.href);
    }
  }, [path, YA_METRIKA_ID]);

  useTracePathname();

  return null;
};
